import React, { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import TokenUsageConsole from '../components/TokenUsageConsole.jsx';

const navItemClasses = ({ isActive }) =>
  `group flex items-center gap-2.5 rounded-md py-2 px-4 text-sm font-medium duration-150 ${
    isActive
      ? 'bg-blue-600 text-white'
      : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
  }`;

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-boxdark-2">
      {/* Sidebar */}
      <aside
        className={`absolute left-0 top-0 z-50 flex h-screen w-64 flex-col border-r border-gray-200 bg-white dark:border-strokedark dark:bg-boxdark transition-transform duration-200 lg:static ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="flex items-center justify-between gap-2 px-6 py-5">
          <button
            className="text-xl font-extrabold tracking-wide text-slate-800 dark:text-white"
            onClick={() => navigate('/admin/dashboard')}
          >
            TIKRAI
          </button>
          <button
            className="lg:hidden inline-flex items-center justify-center rounded-md p-2 text-gray-600 hover:bg-gray-100"
            onClick={() => setSidebarOpen(false)}
            aria-label="Close sidebar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <nav className="mt-2 px-3">
          <ul className="flex flex-col gap-1">
            <li>
              <NavLink to="/admin/dashboard" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12l2-2 4 4 8-8 4 4"/><path d="M14 7h7v7"/></svg>
                </span>
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/products" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/></svg>
                </span>
                <span>Products</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/categories" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 007.6 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 007.6 4.6a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 114 0l.06.06a1.65 1.65 0 001.82.33 1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09c0 .66.39 1.26 1 1.51l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82.33 1.65 1.65 0 00-1 1.51V12c0 .38.07.74.2 1.08"/></svg>
                </span>
                <span>Categories</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/recipes" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 3h16v2H4z"/><path d="M7 5v15a2 2 0 002 2h6a2 2 0 002-2V5"/><path d="M8 14h8"/><path d="M8 10h8"/></svg>
                </span>
                <span>Recipes</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/prices" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1v22"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 110 7H6"/></svg>
                </span>
                <span>Prices</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/normalized" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
                </span>
                <span>Normalized</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/admin/pgvector" className={navItemClasses}>
                <span className="inline-flex h-5 w-5 items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a9 9 0 000 18"/></svg>
                </span>
                <span>pgvector</span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="mt-auto p-4 text-xs text-gray-500">© {new Date().getFullYear()} Tikrai</div>
      </aside>

      {/* Main content area */}
      <div className="relative flex flex-1 flex-col overflow-y-auto">
        {/* Header */}
        <header className="sticky top-0 z-40 flex h-16 w-full items-center gap-4 border-b border-gray-200 bg-white px-4 dark:border-strokedark dark:bg-boxdark">
          <button
            className="inline-flex items-center justify-center rounded-md p-2 text-gray-600 hover:bg-gray-100 lg:hidden"
            onClick={() => setSidebarOpen((s) => !s)}
            aria-label="Open sidebar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
          <div className="flex-1" />
          {/* Token usage console */}
          <TokenUsageConsole />
          <div className="flex items-center gap-3 ml-3">
            <div className="hidden md:block text-sm text-gray-500">Admin</div>
            <div className="h-8 w-8 rounded-full bg-primary/10 text-primary grid place-items-center font-semibold">A</div>
          </div>
        </header>

        {/* Content */}
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
